import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { SiteCredits } from "./components/SiteCredits";
// import { products } from "./data/products";
import "./App.css";
import { getIsStoresLoading, getStores } from "./redux/selectors";
import { fetchStores } from "./redux/stores/operations";
import { RadarLoader } from "./components/RadarLoader";
// import { Announce } from "./components/Announce";
// import { UpdatesBanner } from "./components/UpdatesBanner";

import Home from "./pages/Home";
import Fundraising from "./pages/Fundraising";
import NotFound from "./pages/NotFound";

function App() {
  const dispatch = useDispatch();
  const storesData = useSelector(getStores);
  const isStoresLoading = useSelector(getIsStoresLoading);

  const isDataLoading = isStoresLoading || storesData.length === 0;

  useEffect(() => {
    if (storesData.length === 0) {
      dispatch(fetchStores());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isDataLoading) {
    return <RadarLoader />;
  }

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <div className="App relative" id="home">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fundraising" element={<Fundraising />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <SiteCredits />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
